import $ from 'jquery';
import { runProtectedRoute } from '../middleware';
import { showNavbarPrivateBackButton } from '~src/utils';
import ReactDOM from 'react-dom';
import React from 'react';
import { ProjectsPage } from '~src/components/Projects';
import { trackPageView } from '~src/tracking';

export const projectsRoute = async () => {
  document.title = 'Progetti | Giotto';

  const ready = await runProtectedRoute();
  if (!ready) return;

  showNavbarPrivateBackButton();
  $('#route-projects').show();
  const domContainer = document.querySelector('#route-projects');
  ReactDOM.render(React.createElement(ProjectsPage), domContainer);
  trackPageView('Projects');
};
